"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticsFilteringParameters = void 0;
var StatisticsFilteringParameters = /** @class */ (function () {
    function StatisticsFilteringParameters(tag, fromDate, toDate, messageStream) {
        this.tag = tag;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.messageStream = messageStream;
    }
    return StatisticsFilteringParameters;
}());
exports.StatisticsFilteringParameters = StatisticsFilteringParameters;
//# sourceMappingURL=StatsFilteringParameters.js.map